exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attribute-detail-list[data-v-637f3768] .ivu-table-cell .text-align-dom{display:inline-block;margin:0 auto;text-align:left}.attribute-detail-list[data-v-637f3768] .ivu-table-cell .table-td-class .ivu-btn{margin-right:5px}.attribute-detail-list[data-v-637f3768] .ivu-table-cell .table-td-class .ivu-btn:last-child{margin-right:0}.table-page[data-v-637f3768]{margin:0}.table-page .table-page-right[data-v-637f3768]{float:none;margin-bottom:0;padding:0;text-align:right}.table-page .table-page-right .ivu-page[data-v-637f3768]{display:inline-block}", ""]);

// exports
